import React, { useEffect } from "react";
import "./admin.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Link, Outlet } from "react-router-dom";
function Admin() {
  const navigate = useNavigate();

  const {
    newMailValid,
    currentUser,
    currentUserIsAdmin,
    currentUserIsLawyer,
    currentUserIsCustomer,
    currentUserIsActive,
    allUsers,
  } = useSelector((state) => state.mainReducer);

  // useEffect(()=>{
  //   if(sessionStorage.getItem('type')==null){
  //     navigate("/");

  //   }
  // },[])
  return (
    <>
      <div className="divwala">
        <div className="sidebarr">
          <a
            style={{ textTransformation: "uppercase !important" }}
            className="active"
            href="#home"
          >
            {sessionStorage.getItem("type") =='admin' ? 'ADMIN':'LAWYER'} PANEL
          </a>
          {/* <Link to={"/admin/allusers"}>All Users</Link> */}
          {sessionStorage.getItem("type") === "admin" ? (
            <>
              <Link to={"/admin/lawyers"}>Lawyers</Link>
              <Link to={"/admin/customer"}>Clients</Link>
            </>
          ) : (
            <Link to={"/admin/lawyerRequest"}>Requests</Link>
          )}
        </div>
        <div>
          <div className="contentt">{true ? <Outlet /> : null}</div>
        </div>
      </div>
    </>
  );
}

export default Admin;
